import { SYNC_KEY_PROYECTOS_MACRO_PROYECTOS } from "../../../constantes";
import { MacroProyectoItem, ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { MacroProyectoEstado, MacroProyectoResponse } from "../../../shared/response/proyectos/MacroProyectoResponse";
import { ServiceGetListBase } from "../../../shared/services/base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Macro-Proyectos (agrupadores por cosecha + región) (`ProyectosPlataformaService`, gRPC). */
export class MacroProyectoService extends ServiceGetListBase<MacroProyectoResponse> {
  static readonly instance = new MacroProyectoService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_PROYECTOS_MACRO_PROYECTOS;
  protected readonly sortBy = "nombre";

  /** gRPC-Web (`ListMacroProyectos`): no eliminados, con sus cultivos y los totales de sus proyectos. */
  protected async fetchItems(): Promise<MacroProyectoResponse[]> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).listMacroProyectos({}));
    return r.items.map(toMacroProyectoResponse);
  }

  /** Activa el Macro-Proyecto (`ActivarMacroProyecto`). Si es el primero de su cosecha, también congela esa cosecha. */
  async activar(id: string): Promise<MacroProyectoResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).activarMacroProyecto({ id }));
    const item = toMacroProyectoResponse(r);
    this.upsert(item);
    return item;
  }
}

/** Mensaje gRPC del Macro-Proyecto → `MacroProyectoResponse` (fecha Unix ms → ISO). Lo reusa el guardado. */
export function toMacroProyectoResponse(m: MacroProyectoItem): MacroProyectoResponse {
  return {
    id: m.id,
    isEliminado: false,
    nombre: m.nombre,
    cosechaId: m.cosechaId,
    cosechaNombre: m.cosechaNombre,
    cosechaTasaBaseIpc: m.cosechaTasaBaseIpc,
    cosechaFrozen: m.cosechaFrozen,
    region: m.region,
    estado: m.estado as MacroProyectoEstado,
    fechaActivacion: m.fechaActivacion !== undefined ? new Date(Number(m.fechaActivacion)).toISOString() : null,
    descripcion: m.descripcion ?? null,
    cultivoIds: [...m.cultivoIds],
    cultivoNombres: [...m.cultivoNombres],
    totalProyectos: m.totalProyectos,
    totalHa: m.totalHa,
    montoTotal: Number(m.montoTotal),
    ejecutadoTotal: Number(m.ejecutadoTotal),
    proyectosActivos: m.proyectosActivos,
    proyectosEnRevision: m.proyectosEnRevision,
    proyectosAprobados: m.proyectosAprobados,
  };
}
